
export function useSurfaceEditorStoreScaleManagement({surfaces}) {

  const scale = ref(1);
  const isUserSetScale = ref(false);

  function setScale({scale: s, isUserSet: userSet}) {
    scale.value = s;

    if (userSet) {
      isUserSetScale.value = true;
    }
  }

  const clampScale = (value) => Math.min(SURFACE_EDITOR_MAX_SCALE, Math.max(SURFACE_EDITOR_MIN_SCALE, value));

  function getLargestSurfaceDimensions() {
    if (!surfaces.value?.length) {
      return {width: 0, height: 0};
    }

    return surfaces.value.reduce((dimensions, surface) => ({
      width: Math.max(dimensions.width, surface.width || 0),
      height: Math.max(dimensions.height, surface.height || 0),
    }), {width: 0, height: 0});
  }

  function setScaleForFit({containerWidth, containerHeight, isUserSet}) {

    const {width, height} = getLargestSurfaceDimensions();

    if (!width || !height || !containerWidth || !containerHeight) {
      setScale({scale: clampScale(scale.value), isUserSet});
      return;
    }

    const widthScale = containerWidth / width;
    //this is set to 70 to account for the floating toolbar
    const heightScale = (containerHeight - 70) / height;

    setScale({scale: clampScale(Math.min(widthScale, heightScale)), isUserSet});
  }

  function setScaleForFill({containerWidth, isUserSet}) {
    const {width} = getLargestSurfaceDimensions();

    const nextScale =
      width && containerWidth
        ? clampScale(containerWidth / width)
        : clampScale(scale.value);

    //this is set to 0.98 to account for the scrollbar
    setScale({scale: nextScale * 0.98, isUserSet});
  }

  return {
    scale,
    isUserSetScale,
    setScale,
    setScaleForFit,
    setScaleForFill
  };
}
